"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsafeEditStepCommand = void 0;
const cq_core_1 = require("@leavy/cq-core");
const validator_1 = require("@leavy/validator");
const CommonOnboardingStepId_1 = require("../domain/CommonOnboardingStepId");
const HlOnboardingStepId_1 = require("../../hl/domain/HlOnboardingStepId");
const HodOnboardingStepId_1 = require("../../hod/domain/HodOnboardingStepId");
const base_1 = require("../../base");
const BaseOnboardingCommand_1 = require("./BaseOnboardingCommand");
let UnsafeEditStepCommand = class UnsafeEditStepCommand extends BaseOnboardingCommand_1.BaseOnboardingCommand {
};
__decorate([
    (0, validator_1.IsIn)([
        ...Object.values(CommonOnboardingStepId_1.CommonOnboardingStepId),
        ...Object.values(HlOnboardingStepId_1.HlOnboardingStepId),
        ...Object.values(HodOnboardingStepId_1.HodOnboardingStepId),
    ]),
    __metadata("design:type", String)
], UnsafeEditStepCommand.prototype, "stepId", void 0);
__decorate([
    (0, validator_1.IsOptional)(),
    (0, validator_1.IsObject)(),
    __metadata("design:type", Object)
], UnsafeEditStepCommand.prototype, "data", void 0);
UnsafeEditStepCommand = __decorate([
    (0, cq_core_1.RpcInvocable)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        alias: "unsafe_edit_step",
    })
], UnsafeEditStepCommand);
exports.UnsafeEditStepCommand = UnsafeEditStepCommand;
//# sourceMappingURL=UnsafeEditStepCommand.js.map